export class Setting {
  public id: number;
  // tslint:disable-next-line:variable-name
  public pomodoro_time_length: number;
  // tslint:disable-next-line:variable-name
  public short_rest_time: number;
  // tslint:disable-next-line:variable-name
  public long_rest_time: number;
  // tslint:disable-next-line:variable-name
  public pomodoro_count_after_long_rest: number;
  // tslint:disable-next-line:variable-name
  public start_next_pomodoro_automatic: boolean;
  // tslint:disable-next-line:variable-name
  public start_next_rest_automatic: boolean;
  // tslint:disable-next-line:variable-name
  public send_pomodoro_notification: boolean;
  // tslint:disable-next-line:variable-name
  public send_rest_notification: boolean;
  // tslint:disable-next-line:variable-name
  public be_in_pomodoro_ranking: boolean;
  // tslint:disable-next-line:variable-name
  public pomodoro_sound_id: any;
  // tslint:disable-next-line:variable-name
  public rest_sound_id: any;
  // tslint:disable-next-line:variable-name
  public pomodoro_sound: any;
  // tslint:disable-next-line:variable-name
  public rest_sound: any;
  public dark_mode: boolean;
  constructor(pomodoro_time_length: number = null,
              short_rest_time: number = null,
              long_rest_time: number = null,
              pomodoro_count_after_long_rest: number = null,
              start_next_pomodoro_automatic: boolean = false,
              start_next_rest_automatic: boolean = false,
              send_pomodoro_notification: boolean = false,
              send_rest_notification: boolean = false ,
              be_in_pomodoro_ranking: boolean = false,
              pomodoro_sound_id: any = 1,
              rest_sound_id: any = 2,
              dark_mode: boolean = false
              ) {
    this.pomodoro_time_length = pomodoro_time_length;
    this.short_rest_time = short_rest_time;
    this.long_rest_time = long_rest_time;
    this.pomodoro_count_after_long_rest = pomodoro_count_after_long_rest;
    this.start_next_pomodoro_automatic = start_next_pomodoro_automatic;
    this.start_next_rest_automatic = start_next_rest_automatic;
    this.send_pomodoro_notification = send_pomodoro_notification;
    this.send_rest_notification = send_rest_notification;
    this.be_in_pomodoro_ranking = be_in_pomodoro_ranking;
    this.pomodoro_sound_id = pomodoro_sound_id;
    this.rest_sound_id = rest_sound_id;
    this.dark_mode = dark_mode;
  }
}
